export enum TicketControleQuinquennalStatus {
  A_ASSIGNER = 'A_ASSIGNER',
  A_TRAITER = 'A_TRAITER',
  EN_COURS = 'EN_COURS',
  EN_REMEDIATION = 'EN_REMEDIATION',
  FERME = 'FERME',
  RADIE = 'RADIE',
  ANNULE = 'ANNULE',
  PRE_COMMISSION = 'PRE_COMMISSION',
  PIECES_COMPLEMENTAIRES = 'PIECES_COMPLEMENTAIRES',
}

export type TicketControleQuinquennalType = {
  id: string;
  status: TicketControleQuinquennalStatus;
  dateEnteredEnCoursCollecte: string | null;
  dateEnteredStage: string | null;
  hubspotOwnerId: string | null;
};
